import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initMonitoring, AppErrorBoundary } from './utils/monitoring';
import { initNative } from './utils/native';

// تهيئة مراقبة الأخطاء قبل الـ render (no-op إن لم يُضبط REACT_APP_SENTRY_DSN)
initMonitoring();

// تهيئة غلاف تطبيق أندرويد/iOS (شريط الحالة، شاشة البداية، زر الرجوع، الإشعارات).
// no-op كامل على المتصفح — لا تستورد أي حزمة ولا تنفّذ شيئاً خارج التطبيق النيتف.
initNative();

// بديل بسيط يظهر عند عطل غير متوقّع بدل الشاشة البيضاء
const Fallback = () => (
  <div style={{ fontFamily: 'system-ui, sans-serif', direction: 'rtl', textAlign: 'center', padding: '48px 16px' }}>
    <h2 style={{ margin: '0 0 8px' }}>صار خطأ غير متوقّع</h2>
    <p style={{ color: '#666', margin: '0 0 20px' }}>تم تسجيل المشكلة. جرّب تعيد تحميل الصفحة.</p>
    <button
      onClick={() => window.location.reload()}
      style={{ padding: '10px 22px', borderRadius: 8, border: 'none', background: '#111', color: '#fff', cursor: 'pointer', fontSize: 15 }}
    >
      إعادة تحميل
    </button>
  </div>
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppErrorBoundary fallback={<Fallback />}>
      <App />
    </AppErrorBoundary>
  </React.StrictMode>
);
